<template>
    <div id="index" class="clearfix">
        <div class="center">
            <div class="post_box" style="display: none;">
                <p class="name">发帖</p>
                <div class="area" @click="showEdit()">
                    <!-- <textarea class="zword zw_content" rows="5" cols="10" placeholder="请输入正文"></textarea> -->
                    <p class="zword zw_content" style="font-size:18px;margin:0 0 8px 0;">请输入帖子标题（5-30个汉字）</p>
                    <p class="zword">请输入正文...</p>
                </div>
                <div class="btm">
                    <span class="pic emojiBtn" @click="showUpbox()">图片</span>
                    <span class="emoji emojiBtn">表情</span>
                    <span class="txtNum">字数0/2000字</span>
                    <a class="send" href="javascript:;">发布</a>
                    <div class="loadBox" v-show="showUpload">
                        <p>本地上传</p>
                        <el-form>
                            <el-upload
                                action="api/v1/upload?token=WUrxJnNqXWJJyjpYcu56aqvyjdjUx6yX"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove"
                                :http-request="uploadImg">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form>
                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                        <i class="close" @click="hideUpload"></i>
                    </div>
                </div>
            </div>
            <div class="noread" v-show="showAlarm">
                您有未读内容，点击查看
                <span class="close" @click="closeTitle()"></span>
            </div>
            <div class="newsList">
                <ul>
                    <!-- 无图片 -->
                    <li class="clearfix" v-for="(item,i) in threadlist">
                        <div class="noImg" v-if="item.thumbs&&item.thumbs.length==0">
                            <h3 class="title" @click="intoDetail(item.tid)">{{item.subject}}</h3>
                            <div class="btm_txt">
                                <span class="tag" v-if="item.tit!=''">{{item.tit}}</span>
                                <img class="avatar" :src="item.avatar?item.avatar:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                <a  class="msg" href="javascript:;">{{item.author}}·{{item.replies}}评论·{{item.dateline | catipTime}}分钟</a>
                                <i class="close"  @click="closeList(i)"></i>
                            </div>
                        </div>
                    <!-- 左图右字 -->
                        <div class="clearfix" v-if="item.thumbs&&item.thumbs.length>0 &&item.thumbs.length<3">
                            <div class="left_img" :style="{backgroundImage:'url('+item.thumbs[0]+')'}">
                                <!-- <img class="l_img" :src="item.thumbs[0]" alt=""> -->
                            </div>
                            <div class="hasOne">
                                <h3 class="title" @click="intoDetail(item.tid)">{{item.subject}}</h3>
                                <div class="btm_txt">
                                    <span class="tag" v-if="item.tit!=''">{{item.tit}}</span>
                                    <img class="avatar" :src="item.avatar?item.avatar:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                    <a  class="msg" href="javascript:;">{{item.author}}·{{item.replies}}评论·{{item.dateline | catipTime}}分钟</a>
                                    <i class="close" @click="closeList(i)"></i>
                                </div>
                            </div>
                        </div>
                        <!-- 三张图显示 -->
                        <div class="noImg hasMore" v-if="item.thumbs&&item.thumbs.length>=3 ">
                            <h3 class="title" @click="intoDetail(item.tid)">{{item.subject}}</h3>
                            <ul class="imgs_list clearfix">
                                <li v-for="(timg,k) in item.thumbs">
                                    <img :src="timg?timg:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                </li>
                            </ul>
                            <div class="btm_txt">
                                <span class="tag blue" v-if="item.tit!=''">{{item.tit}}</span>
                                <img class="avatar" :src="item.avatar?item.avatar:'http://dev.linyouquan.net/imgs/topic/noavatar_big.gif'" alt="">
                                <a  class="msg" href="javascript:;">{{item.author}}·{{item.replies}}评论·{{item.dateline}}分钟</a>
                                <i class="close" @click="closeList(i)"></i>
                            </div>
                        </div>
                    </li>
                </ul>
                <infinite-loading @infinite="infiniteHandler">
                  <span slot="no-more">
                    我们是有底线的
                  </span>
                </infinite-loading>
                <!-- <li v-if="threadlist.length > 0"
                  style="padding: 20px; color: #999; text-align: center; background: #fff;">
                  -- 已加载全部 --
                </li>
                <li v-if="threadlist.length ==0"
                  style="padding: 20px; color: #999; text-align: center; background: #fff;">
                  -- 暂无内容 --
                </li> -->
            </div>
            <!-- <div class="refresh" @click="refresh"> -->
                <!-- 4小时前看到这里 点击刷新<img src="~@/assets/imgs/ref.png" alt="·"> -->
            <!--{{message}}
            </div> -->
        </div>
        <div class="right_box">
            <div class="search clearfix">
                <input type="text" class="" v-model="keywords" @click="intoSearch(keywords,$event)" placeholder="请输入要搜索的内容">
                <a href="javascript:;" class="search_btn" @click="intoSearch(keywords)">搜索</a>
            </div>
            <!-- 用户信息登录未登录 -->
            <Loginbox :name="index"></Loginbox>
            <!-- 广告 -->
            <div class="adv_box" style="display: none;">
                <div class="imgBox">
                    <el-carousel height="210px">
                        <el-carousel-item v-for="item in 4" :key="item">
                            <img src="http://dev.linyouquan.net/uploads/2019/09/12/VCMCl.jpeg" alt="">
                        </el-carousel-item>
                    </el-carousel>
                    <span class="show">广告</span>
                </div>
            </div>
            <!-- 24h热帖 -->
            <Hot></Hot>
            <!-- 热门活动 -->
            <Hotactive></Hotactive>
        </div>
        <div class="send_mask" v-show="edit_switch">
            <div class="send_inner">
                <i class="close" @click="hideEdit()"></i>
                <p class="top">发布帖子</p>
                <div class="editor_box">
                    <div class="title">
                        <input type="text" placeholder="请输入帖子标题（5-30个汉字）">
                    </div>
                    <quill-editor
                        v-model="content"
                        ref="myQuillEditor"
                        :options="editorOption"
                        @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                        @change="onEditorChange($event)">
                    </quill-editor>
                    <div class="sendBtn">
                        <a href="javascript:;" @click="hideEdit()">发 布</a>
                    </div>
                </div>

                <!-- <div v-html="content">
                    {{content}}
                </div> -->
            </div>
        </div>

    </div>
</template>

<script>
import service from '@/api/service/service'
import VueQuillEditor from 'vue-quill-editor'
import Hot from '../common/hot'
import Hotactive from '../common/Hotactive'
import Loginbox from '../common/loginBox'
import InfiniteLoading from 'vue-infinite-loading';

export default {
    filters:{
        catipTime:function(val) {
            if(!val) return ''
            return Math.floor((val/1000)/60/60/60)
        }
    },
    components:{
        VueQuillEditor,
        Hot,
        Hotactive,
        Loginbox,
        InfiniteLoading
    },
    data() {
        return {
            index:this.$route.name,//获取当前页面的路由name
            keywords:'',
            edit_switch:false,
            content:null,
            editorOption:{},
            threadlist:[],
            // currentPage4: 4,
            tid:'',
            dialogImageUrl: '',
            dialogVisible: false,
            showUpload:false,
            loading: false,//加载更多
            showAlarm:false,
            page:1, //
            message:'4小时前看到这里 点击刷新',
            tipsNumber:0,
            isSwitch:false
        }
    },
    computed:{
    },
    mounted() {
        this.loading = true
        this.getLists()
    },
    methods:{
      infiniteHandler($state) {
          setTimeout(() => {
            const temp = [];
            for (let i = this.list.length + 1; i <= this.list.length + 20; i++) {
              temp.push(i);
            }
            this.list = this.list.concat(temp);
            $state.loaded();
            $state.complete();
          }, 1000);
      },
        // 进入搜索
        intoSearch(val,e) {
            if(e && e.keyCode != '13') {
                return
            }else{
                this.$router.push({path:`/search?keywords=${val}`})  //跳转到搜索页传一个keywords关键字
            }
        },
        onEditorChange({ editor, html, text }) {
        // console.log('editor change!', editor, html, text)
            this.content = html
        },
        closeTitle() {
            this.showAlarm = false
        },
        // 图片上传
        uploadImg(item) {
            let formData = new FormData()
            formData.append('file', item.file)
            formData.append('group', 'system')

                Api.uploadFile({
                data: formData  // 选择FormData方式传参
            })
            .then((data) => {
                console.log(data)
            })
            .catch((err) => {
                console.log(err, 'error');
            });
        },
        handleRemove(file, fileList) {
            console.log(file);
            console.log(fileList)
        },
        showUpbox() {
            this.showUpload = true
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            router.beforeEach((to, from, next) => {
            })
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        intoDetail(tid) {
            // let routeData = this.$router.resolve({
            //     path: `/newsdetail/${tid}`,
            // });
            // if(!tid) {
            //     window.open(url, '_blank');
            // }else{
            //     window.open(routeData.href, '_blank');
            // }
            const a = document.createElement('a');
            a.href = `${this.commonIp}/v1/threads/` + tid
            a.target = "_blank"
            a.click()
        },
        getLists() {
            this.loading = true
            service.get(`/api/v1/homeNew?page=${this.page}&history=0&lastId=${this.lastId}`).then((res) => {
                if (res.data.code == 200) {
                  let data = res.data.data
                  let {threadlist ,tipsNumber} = data
                  if(threadlist.length!=0){
                  	var list = [];
                  	for(var i=0;i<threadlist.length;i++){
                  		let item = threadlist[i];
                      list.push(item);
                  		if(typeof(threadlist[i].id)!='undefined'&&threadlist[i].id) {
                  			this.lastId = item.id
                  		}
                  	}
                    if(threadlist.length<=15&&threadlist.length!=0) {
                        this.page+=1
                    }
                  	threadlist = list
                  	this.threadlist = [...this.threadlist, ...threadlist]
                  }else{
                    this.loading = true
                        this.isSwitch = true
                  }

                  this.tipsNumber = tipsNumber
                }
                // console.log(this.threadlist)
            })
            .catch((err)=>{

            })
            .finally(()=>{
              this.loading = false
            })
        },
        // 删除当前一条
        closeList(i) {
            this.threadlist.splice(i,1)
        },
        // 点击刷新
        // refresh() {
        //   this.page =1
        //   setTimeout(()=> {
        //   	this.threadlist = []
        //     this.lastId = ''
        //   	this.getLists()
        //   },0)

        //   if(this.tipsNumber > 0){
        //     this.message ='邻友圈引擎为您推荐' + this.tipsNumber + '条更新'
        //   }else{
        //     this.message = '邻友圈引擎暂无更多新数据可推荐'
        //   }
        // },
        // 关闭上传图片
        hideUpload() {
            this.showUpload = false
        },
        onEditorBlur(){//失去焦点事件
        },
        onEditorFocus(){//获得焦点事件
        },
        onEditorChange(e){//内容改变事件
            console.log(e.html)
        },
        showEdit() {
            this.edit_switch = true
        },
        hideEdit() {
            this.edit_switch = false
        },
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';

.send_mask{
    position: fixed;
    width:100%;
    height: 100%;
    background:rgba(0,0,0,.5);
    left:0;
    top:0;
    z-index:9999;
    .send_inner{
        width:820px;
        height: 500px;
        position: absolute;
        left:50%;
        top:50%;
        margin-left:-410px;
        margin-top:-250px;
        background:#fff;
        .sendBtn{
            text-align: right;
            margin:30px 0 20px 0;
            a{
                width:104px;
                height: 34px;
                background:#f58c8b;
                text-align: center;
                line-height: 34px;
                color:#fff;
                display: inline-block;
            }
        }
        .close{
            position: absolute;
            right:15px;
            top:15px;
            cursor: pointer;
            display: inline-block;
            width:20px;
            height: 20px;
            background: url("~@/assets/imgs/close1.png") no-repeat top center;;
        }
        p.top{
            height: 50px;
            line-height: 50px;
            font-size:18px;
            padding:0 20px;
        }
        .editor_box{
            background:#f4f5f6;
            padding:15px 20px;
            .ql-container{
                height:300px;
            }
            .title{
                margin:0 0 20px 0;
                height:50px;
                line-height: 50px;
                background:#fff;
                input{
                    height: 100%;
                    width:100%;
                    border:0;
                    padding:0 0 0 20px;
                    outline: none;
                }
            }
        }
    }
}
    #index{
        width:100%;
        .right_box{
            width:280px;
            margin:0 0 0 25px;
            .fr();
            .search{
                height:40px;
                line-height: 40px;
                border:1px solid #ededed;
                width:100%;
                border-radius:5px;
                input{
                    height:100%;
                    border:0;
                    width:80%;
                    background:#f4f5f6;
                    float: left;
                    padding:0 0 0 8px;
                }
                .search_btn{
                    width: 20%;
                    height: 100%;
                    text-align: center;
                    display: inline-block;
                    color:#fff;
                    font-size:@ft20;
                    border-radius:0 5px 5px 0;
                    background:#FF4C45;
                }
            }
            .adv_box{
                padding:20px 18px;
                background:@gray;
                .imgBox{
                    border:3px solid #FF4C45;
                    overflow: hidden;
                    width: 100%;
                    height: 210px;
                    text-align: center;
                    position: relative;
                    img{
                        width:auto;
                        vertical-align: middle;
                        height: 100%;
                    }
                    .show{
                        position: absolute;
                        right:0;
                        bottom:0;
                        display: inline-block;
                        font-size:11px;
                        width:42px;
                        height:20px;
                        line-height: 20px;
                        color:#898989;
                        text-align: center;
                        background:rgba(236,236,236,0.9);
                    }
                }
            }
        }
        .post_box{
            width:100%;
            border:1px solid #ededed;
            .name{
                padding:0 20px;
                height:38px;
                font-weight: bold;
                line-height: 38px;
            }
            .area{
                padding:15px 20px;
                background:#f4f5f6;
                color:#5c5c5c;
                .title{
                    font-size:@ft20;
                    height:35px;
                }
                .zword{
                    font-size:@ft14;
                }
            }
            .btm{
                padding:0 0 0 20px;
                height:35px;
                line-height: 35px;
                position: relative;
                span{
                    font-size:@ft14;
                }
                .send{
                    width:104px;
                    .fr();
                    display: inline-block;
                    background:#f58c8b;
                    color:#fff;
                    text-align: center;
                    font-size:@ft20;
                    &.active{
                        background:#ed4040;
                    }
                }
                .emojiBtn{
                    background: url('~@/assets/imgs/pic.png') no-repeat left center;
                    background-size:24px;
                    display: inline-block;
                    padding-left:32px;
                    height: 100%;
                    cursor: pointer;
                    &.emoji{
                        margin:0 10px 0;
                        background-image: url('~@/assets/imgs/pic2.png');
                    }
                }
                .loadBox{
                    width:420px;
                    padding:12px;
                    height:246px;
                    background: #fff;
                    position: absolute;
                    left:0;
                    border:1px solid #e8e8e8;
                    box-shadow: 0 2px 15px rgba(0,0,0,.12);
                    top:40px;
                    &:before{
                        content: "";
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        border-bottom-color: #e8e8e8;
                        position: absolute;
                        top: -16px;
                        left: 45px;
                    }
                    .el-upload--picture-card{
                        width: 72px;
                        height: 72px;
                        line-height: 72px;
                    }
                    .el-upload-list--picture-card .el-upload-list__item{
                        width:72px;
                        height: 72px;
                    }
                    .close{
                        cursor: pointer;
                        position: absolute;
                        right:10px;
                        top:10px;
                        display: inline-block;
                        width:20px;
                        height: 20px;
                        background: url('~@/assets/imgs/close1.png') no-repeat;
                    }
                }
            }
        }
        .noread{
            margin:10px 0;
            line-height:28px;
            height:28px;
            text-align:center;
            color:#fff;
            padding:0 10px 0 0;
            background: @lightblue;
            .close{
                display:inline-block;
                width:20px;
                text-align: center;
                height: 15px;
                margin:7px 0 0 0;
                .fr();
                background:url(~@/assets/imgs/close.png) no-repeat right center;
                background-size:12px;
                cursor: pointer;
            }
        }
        .refresh{
            width:100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border:1px solid #8ec4ec;
            background:#eef6fc;
            color:#2d8ed9;
            margin:12px 0;
            cursor: pointer;
            img{
                width:14px;
                margin:0 0 0 8px;
                vertical-align: middle;
            }
        }
        .zw_content{
            width:100%;
            height:auto;
            outline: none;
            font-size:18px;
            background:#f4f5f6;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/test/test.vue